import { CONVERTER_COMMON_LANG } from "./common";
import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_MY_DICTIONARY_LANG: {
  SDTM_TAB: MvnCodeFE;
  ADAM_TAB: MvnCodeFE;
  MY_DICTIONARY_TAB: MvnCodeFE;
  MY_DICTIONARY_VARIABLE_SEARCH_PLACEHOLDER: MvnCodeFE;
  SDTM_LIST_EMPTY: MvnCodeFE;
  SDTM_LIST_TOOLTIP_ADD: MvnCodeFE;
  SDTM_LIST_TOOLTIP_PIN: MvnCodeFE;
  SDTM_LIST_TOAST_TERMINOLOGY_ADD_SUCCEED: MvnCodeFE;
  SDTM_LIST_TOAST_TERMINOLOGY_ADD_FAIL: MvnCodeFE;
  MY_DICTIONARY_LIST_EMPTY: MvnCodeFE;
  MY_DICTIONARY_LIST_MENU_UPDATE: MvnCodeFE;
  MY_DICTIONARY_LIST_MENU_DELETE: MvnCodeFE;
  MY_DICTIONARY_LIST_FOOTER_BUTTON_MANAGEMENT: MvnCodeFE;
  MY_DICTIONARY_LIST_FOOTER_BUTTON_EXPORT: MvnCodeFE;
  MY_DICTIONARY_LIST_FOOTER_BUTTON_IMPORT: MvnCodeFE;
  MY_DICTIONARY_TOAST_EXPORT_SUCCESS: MvnCodeFE;
  MY_DICTIONARY_TOAST_EXPORT_FAIL: MvnCodeFE;
  MY_DICTIONARY_DIALOG_EMPTY: MvnCodeFE;
  MY_DICTIONARY_DIALOG_TITLE: MvnCodeFE;
  MY_DICTIONARY_DIALOG_ADD_GROUP_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_ADD_GROUP_BUTTON: MvnCodeFE;
  MY_DICTIONARY_DIALOG_FORM_GROUP_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_FORM_NCI_CODE_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_FORM_SUBMISSION_VALUE_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_FORM_SYNONYM_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_FORM_DECODED_VALUE_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_FORM_RANK_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DIALOG_ADD_TERM_DEFAULT_NAME: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DRAFTED_ITEM: MvnCodeFE;
  MY_DICTIONARY_DIALOG_EDITED_ITEM: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DRAFTING_ITEM: MvnCodeFE;
  MY_DICTIONARY_DIALOG_EDITING_ITEM: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DUPLICATE_CODELIST_NAME: MvnCodeFE;
  MY_DICTIONARY_TOAST_TERMINOLOGY_EDIT_SUCCEED: MvnCodeFE;
  MY_DICTIONARY_TOAST_TERMINOLOGY_EDIT_FAIL: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DELETE_TERMINOLOGY: MvnCodeFE;
  MY_DICTIONARY_TOAST_TERMINOLOGY_DELETE_SUCCEED: MvnCodeFE;
  MY_DICTIONARY_TOAST_TERMINOLOGY_DELETE_FAIL: MvnCodeFE;
  MY_DICTIONARY_DIALOG_SYNONYM_CONFIRM_TITLE: MvnCodeFE;
  MY_DICTIONARY_DIALOG_SYNONYM_CONFIRM_DESCRIPTION: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DISCARD_CONFIRM_TITLE: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DISCARD_CONFIRM_DESCRIPTION: MvnCodeFE;
  MY_DICTIONARY_DIALOG_DISCARD_CONFIRM_BUTTON: MvnCodeFE;

  MY_DICTIONARY_UPLOAD_MENU_SUBMIT: MvnCodeFE;
  MY_DICTIONARY_UPLOAD_MENU_TEMPLATE: MvnCodeFE;

  MY_DICTIONARY_DIALOG_DELETE: MvnCodeFE;
  MY_DICTIONARY_DIALOG_CONFIRM: MvnCodeFE;
  MY_DICTIONARY_DIALOG_CANCEL: MvnCodeFE;
  MY_DICTIONARY_DIALOG_SAVE: MvnCodeFE;

  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_TITLE: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_DESCRIPTION: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_LABEL: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_PLACEHOLDER: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_CANCEL: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_ADD: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_KEEP_ADDING: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_NEW: MvnCodeFE;
  MY_DICTIONARY_TOAST_TERMINOLOGY_ALREADY_EXIST: MvnCodeFE;
  MY_DICTIONARY_DUPLICATION_CODELIST_DRAWER_TITLE: MvnCodeFE;

  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_TITLE: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_DESCRIPTION: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_TOTAL: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_NEW: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_OVERWRITE: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_FAIL: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_ITEM: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_REPORT_DOWNLOAD_BUTTON: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_PROCEED: MvnCodeFE;
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_CANCEL: MvnCodeFE;
  MY_DICTIONARY_TOAST_IMPORT_SUCCESS: MvnCodeFE;
  MY_DICTIONARY_TOAST_IMPORT_WITH_FAIL_COUNT_SUCCESS: MvnCodeFE;
  MY_DICTIONARY_TOAST_IMPORT_FILE_TYPE_INVALID: MvnCodeFE;
  MY_DICTIONARY_TOAST_IMPORT_FAIL: MvnCodeFE;

  MY_DICTIONARY_VALIDATION_REQUIRED_SHEET_EXISTS_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_REQUIRED_COLUMN_EXISTS_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_COLUMN_ORDINAL_MATCH_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_MINIMUM_ROW_COUNT_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_MAXIMUM_ROW_COUNT_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_MAXIMUM_FILE_SIZE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_REQUIRED_CODE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_REQUIRED_CODELIST_NAME_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_REQUIRED_SUBMISSION_VALUE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_REQUIRED_CODELIST_EXTENSIBLE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_CODE_FORMAT_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_CODELIST_CODE_FORMAT_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_CODELIST_EXTENSIBLE_VALUE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_RANK_NUMERIC_FORMAT_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_TERM_CODE_INTEGRITY_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_GROUP_CUSTOM_CODE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_CUSTOM_CODE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_NON_EXTENSIBLE_CODE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_DUPLICATION_CODE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_STANDARD_CODE_COMPLIANCE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_STANDARD_VALUE_COMPLIANCE_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_CODELIST_NAME_MAX_LENGTH_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_SUBMISSION_VALUE_MAX_LENGTH_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_DECODED_VALUE_MAX_LENGTH_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_SYSTEM_ID_MATCH_RULE: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_LOADING: MvnCodeFE;
  MY_DICTIONARY_VALIDATION_PROCEED_LOADING: MvnCodeFE;
} = {
  SDTM_TAB: {
    ko: "SDTM CT",
    en: "SDTM CT",
  },
  ADAM_TAB: {
    ko: "ADaM CT",
    en: "ADaM CT",
  },
  MY_DICTIONARY_TAB: {
    ko: "My Dictionary",
    en: "My Dictionary",
  },
  MY_DICTIONARY_VARIABLE_SEARCH_PLACEHOLDER: {
    ko: "Variable name으로 검색",
    en: "Search by Variable name",
  },
  SDTM_LIST_EMPTY: {
    ko: "조회된 데이터가 없습니다.",
    en: "No data found.",
  },
  SDTM_LIST_TOOLTIP_ADD: {
    ko: "My Dictionary에 추가",
    en: "Add to My Dictionary",
  },
  SDTM_LIST_TOOLTIP_PIN: {
    ko: "현재 그룹에 추가",
    en: "Add to current group",
  },
  SDTM_LIST_TOAST_TERMINOLOGY_ADD_SUCCEED: {
    ko: "My Dictionary에 추가했습니다.",
    en: "It has been added to my dictionary.",
  },
  SDTM_LIST_TOAST_TERMINOLOGY_ADD_FAIL: {
    ko: "My Dictionary 추가에 실패했습니다.",
    en: "Failed to add to my dictionary.",
  },
  MY_DICTIONARY_LIST_EMPTY: {
    ko: "추가된 데이터가 없습니다.",
    en: "There is no data.",
  },
  MY_DICTIONARY_LIST_MENU_UPDATE: CONVERTER_COMMON_LANG.EDIT_VERB,
  MY_DICTIONARY_LIST_MENU_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  MY_DICTIONARY_LIST_FOOTER_BUTTON_MANAGEMENT: {
    ko: "용어 관리",
    en: "CT Management",
  },
  MY_DICTIONARY_LIST_FOOTER_BUTTON_EXPORT: {
    ko: "내보내기",
    en: "Export",
  },
  MY_DICTIONARY_LIST_FOOTER_BUTTON_IMPORT: {
    ko: "업로드",
    en: "Upload",
  },
  MY_DICTIONARY_TOAST_EXPORT_SUCCESS: {
    ko: "내보내기를 완료했습니다.",
    en: "My Dictionary has been exported.",
  },
  MY_DICTIONARY_TOAST_EXPORT_FAIL: {
    ko: "내보내기에 실패했습니다.",
    en: "Failed to export the My Dictionary.",
  },
  MY_DICTIONARY_DIALOG_TITLE: {
    ko: "용어 관리",
    en: "CT Management",
  },
  MY_DICTIONARY_DIALOG_EMPTY: {
    ko: "등록된 코드가 없습니다.",
    en: "Code not found.",
  },
  MY_DICTIONARY_DIALOG_ADD_GROUP_PLACEHOLDER: {
    ko: "코드리스트명(그룹 이름) 입력",
    en: "Enter the Codelist name(Group name)",
  },
  MY_DICTIONARY_DIALOG_ADD_GROUP_BUTTON: {
    ko: "추가",
    en: "Add",
  },
  MY_DICTIONARY_DIALOG_FORM_GROUP_PLACEHOLDER: {
    ko: "코드리스트명(그룹명) 입력",
    en: "CodelistName(Group name)",
  },
  MY_DICTIONARY_DIALOG_FORM_NCI_CODE_PLACEHOLDER: {
    ko: "CDISC/NCI Code",
    en: "CDISC/NCI Code",
  },
  MY_DICTIONARY_DIALOG_FORM_SUBMISSION_VALUE_PLACEHOLDER: {
    ko: "제출 용어",
    en: "Terminology for submission",
  },
  MY_DICTIONARY_DIALOG_FORM_SYNONYM_PLACEHOLDER: {
    ko: "제출 용어에 대한 동의어",
    en: "A word or phrase with the same meaning for a submission value.",
  },
  MY_DICTIONARY_DIALOG_FORM_DECODED_VALUE_PLACEHOLDER: {
    ko: "사용자 정의 용어",
    en: "The decoded value becoming the display value.",
  },
  MY_DICTIONARY_DIALOG_FORM_RANK_PLACEHOLDER: {
    ko: "등급",
    en: "Rank",
  },
  MY_DICTIONARY_DIALOG_ADD_TERM_DEFAULT_NAME: {
    ko: "제목 없음",
    en: "Untitled",
  },
  MY_DICTIONARY_DIALOG_DRAFTED_ITEM: {
    ko: "작성됨",
    en: "Drafted",
  },
  MY_DICTIONARY_DIALOG_EDITED_ITEM: {
    ko: "수정됨",
    en: "Edited",
  },
  MY_DICTIONARY_DIALOG_DRAFTING_ITEM: {
    ko: "작성중",
    en: "Drafting",
  },
  MY_DICTIONARY_DIALOG_EDITING_ITEM: {
    ko: "수정중",
    en: "Editing",
  },
  MY_DICTIONARY_DIALOG_DUPLICATE_CODELIST_NAME: {
    ko: "중복된 Codelist Name이 존재합니다.",
    en: "Duplicate Codelist Name exists.",
  },
  MY_DICTIONARY_TOAST_TERMINOLOGY_EDIT_SUCCEED: {
    ko: "그룹 또는 단일 용어를 수정했습니다.",
    en: "The codelist(group) or terminology has been modified.",
  },
  MY_DICTIONARY_TOAST_TERMINOLOGY_EDIT_FAIL: {
    ko: "그룹 또는 단일 용어 수정에 실패했습니다.",
    en: "Failed to modify the codelist(group) or terminology.",
  },
  MY_DICTIONARY_DIALOG_DELETE_TERMINOLOGY: {
    ko: "선택한 그룹 또는 단일 용어를 삭제하시겠습니까?",
    en: "Are you sure you want to delete the selected codelist(group) or terminology?",
  },
  MY_DICTIONARY_TOAST_TERMINOLOGY_DELETE_SUCCEED: {
    ko: "그룹 또는 단일 용어를 삭제했습니다.",
    en: "The codelist(group) or terminology has been deleted.",
  },
  MY_DICTIONARY_TOAST_TERMINOLOGY_DELETE_FAIL: {
    ko: "그룹 또는 단일 용어 삭제에 실패했습니다.",
    en: "Failed to delete the codelist(group) or terminology.",
  },
  MY_DICTIONARY_DIALOG_SYNONYM_CONFIRM_TITLE: {
    ko: "Synonym 선택",
    en: "Select Synonym",
  },
  MY_DICTIONARY_DIALOG_SYNONYM_CONFIRM_DESCRIPTION: {
    ko: "{submissionValue}에 대해 1개의 Synonym을 선택해 주세요.",
    en: "Please select one synonym for {submissionValue}.",
  },

  MY_DICTIONARY_DIALOG_DISCARD_CONFIRM_TITLE: {
    ko: "저장하지 않고 편집을 종료하시겠습니까?",
    en: "Close without saving?",
  },
  MY_DICTIONARY_DIALOG_DISCARD_CONFIRM_DESCRIPTION: {
    ko: "‘닫기’를 선택하면 편집창이 저장 없이 닫히며, 변경 내용은 스터디에 반영되지 않습니다.\n편집 내용을 저장하려면 ‘취소’를 선택한 후 ‘저장’을 눌러주세요.",
    en: "Selecting ‘Close’ will close the editor without saving, and your changes will not be applied to the study.\nTo save your changes, select ‘Cancel’ and then choose ‘Save’.",
  },
  MY_DICTIONARY_DIALOG_DISCARD_CONFIRM_BUTTON: {
    ko: "저장하지 않고 닫기",
    en: "Close without saving",
  },

  MY_DICTIONARY_UPLOAD_MENU_SUBMIT: {
    ko: "등록하기",
    en: "Submit",
  },
  MY_DICTIONARY_UPLOAD_MENU_TEMPLATE: {
    ko: "템플릿 다운로드",
    en: "Download Template",
  },

  MY_DICTIONARY_DIALOG_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  MY_DICTIONARY_DIALOG_CONFIRM: CONVERTER_COMMON_LANG.CONFIRM_VERB,
  MY_DICTIONARY_DIALOG_SAVE: CONVERTER_COMMON_LANG.SAVE_VERB,
  MY_DICTIONARY_DIALOG_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,

  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_TITLE: {
    ko: "동일한 Codelist 존재",
    en: "Duplicate Codelist Detected",
  },
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_DESCRIPTION: {
    ko: "이 용어에 대한 Codelist가 이미 존재합니다.\n용어를 기존 Codelist에 추가하거나, 새로운 Codelist로 생성할 수 있습니다.",
    en: "A Codelist for this term already exists.\nYou may add the term to an existing Codelist or create a new Codelist.",
  },
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_LABEL: {
    ko: "동일 Codelist 목록",
    en: "Existing Codelist(s)",
  },
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_PLACEHOLDER: {
    ko: "선택",
    en: "Select",
  },
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_ADD: CONVERTER_COMMON_LANG.ADD_VERB,
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_KEEP_ADDING: {
    ko: "선택한 Codelist에 계속 추가",
    en: "Continue adding to the selected Codelist",
  },
  MY_DICTIONARY_DUPLICATION_CODELIST_DIALOG_NEW: {
    ko: "새로운 Codelist로 추가",
    en: "Add as a new Codelist",
  },
  MY_DICTIONARY_TOAST_TERMINOLOGY_ALREADY_EXIST: {
    ko: "추가 하려는 용어가 Codelist에 존재합니다.",
    en: "The term you are trying to add already exists in the Codelist",
  },
  MY_DICTIONARY_DUPLICATION_CODELIST_DRAWER_TITLE: {
    ko: "중복 용어 관리",
    en: "Duplicate Term Management",
  },

  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_TITLE: {
    ko: "업로드 미리보기",
    en: "Upload Preview",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_DESCRIPTION: {
    ko: "업로드할 파일의 검증 결과입니다.\n\n계속 진행할 경우 기저장된 정보가 소실되며 새로운 정보가 입력됩니다.\n\n계속 진행하시겠습니까?",
    en: "This is the validation result for the file to be uploaded.\n\nContinuing will overwrite existing data.\n\nDo you want to proceed?",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_TOTAL: {
    ko: "총 요청",
    en: "Total requests",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_NEW: {
    ko: "신규 등록 예정",
    en: "Add new",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_OVERWRITE: {
    ko: "덮어쓰기 에정",
    en: "Overwrite",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_FAIL: {
    ko: "실패 예상",
    en: "Failed",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_ITEM: {
    ko: "건",
    en: "",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_REPORT_DOWNLOAD_BUTTON: {
    ko: "리포트 다운로드",
    en: "Download report",
  },
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_CANCEL: CONVERTER_COMMON_LANG.CANCEL_VERB,
  MY_DICTIONARY_IMPORT_VALIDATION_DIALOG_PROCEED: {
    ko: "계속 진행",
    en: "Proceed",
  },
  MY_DICTIONARY_TOAST_IMPORT_SUCCESS: {
    ko: "총 {total}건 중 신규 {newCount}건 처리되었습니다.",
    en: "Processed {total} items: {newCount} new created.",
  },
  MY_DICTIONARY_TOAST_IMPORT_WITH_FAIL_COUNT_SUCCESS: {
    ko: "총 {total}건 중 {successCount}건 성공, {failCount}건 실패하였습니다.",
    en: "Processed {total} items: {successCount} succeeded, {failCount} failed.",
  },
  MY_DICTIONARY_TOAST_IMPORT_FILE_TYPE_INVALID: {
    ko: "지원하지 않는 파일 형식입니다. Excel 파일(.xlsx)을 업로드해 주세요.",
    en: "Unsupported file format. Please upload an Excel file (.xlsx).",
  },
  MY_DICTIONARY_TOAST_IMPORT_FAIL: {
    ko: "파일 업로드 처리에 실패했습니다.",
    en: "Failed to process the file upload.",
  },
  MY_DICTIONARY_VALIDATION_REQUIRED_SHEET_EXISTS_RULE: {
    ko: "유효하지 않은 파일 포맷입니다. 필수 시트 'My Dictionary'가 없습니다.",
    en: "Invalid file format. Required sheet 'My Dictionary' not found.",
  },
  MY_DICTIONARY_VALIDATION_REQUIRED_COLUMN_EXISTS_RULE: {
    ko: "필수 컬럼이 누락되었습니다. {value}",
    en: "Missing required columns. {value}",
  },
  MY_DICTIONARY_VALIDATION_COLUMN_ORDINAL_MATCH_RULE: {
    ko: "컬럼 순서가 템플릿과 일치하지 않습니다. Export로 받은 템플릿 파일을 사용해주세요.",
    en: "Column order does not match template. Please use the template file from export.",
  },
  MY_DICTIONARY_VALIDATION_MINIMUM_ROW_COUNT_RULE: {
    ko: "데이터가 없습니다. 최소 1개 이상의 데이터 행이 필요합니다.",
    en: "No data found. At least 1 data row is required.",
  },
  MY_DICTIONARY_VALIDATION_MAXIMUM_ROW_COUNT_RULE: {
    ko: "데이터 행이 너무 많습니다. 최대 10,000개까지 처리 가능합니다. (현재: {value}개)",
    en: "Too many data rows. Maximum 10,000 rows are allowed. (Current: {value} rows)",
  },
  MY_DICTIONARY_VALIDATION_MAXIMUM_FILE_SIZE_RULE: {
    ko: "파일 크기가 너무 큽니다. 10MB 이하의 파일을 업로드해 주세요. (현재 크기: {value})",
    en: "File size is too large. Please upload a file smaller than 10MB. (Current size: {value})",
  },
  MY_DICTIONARY_VALIDATION_REQUIRED_CODE_RULE: {
    ko: "Code 값이 비어있습니다.",
    en: "Code value is empty.",
  },
  MY_DICTIONARY_VALIDATION_REQUIRED_CODELIST_NAME_RULE: {
    ko: "Codelist name 값이 비어있습니다.",
    en: "Codelist name value is empty.",
  },
  MY_DICTIONARY_VALIDATION_REQUIRED_SUBMISSION_VALUE_RULE: {
    ko: "하위 코드이지만 CDISC Submission Value가 비어있습니다.",
    en: "CDISC Submission Value is required for sub codes.",
  },
  MY_DICTIONARY_VALIDATION_REQUIRED_CODELIST_EXTENSIBLE_RULE: {
    ko: "그룹 코드이지만 Codelist Extensible 값이 비어있습니다.",
    en: "Codelist Extensible is required for group codes.",
  },
  MY_DICTIONARY_VALIDATION_CODE_FORMAT_RULE: {
    ko: "Code 형식이 잘못되었습니다. CT는 'C숫자' 형식, Custom은 '*' 형식이어야 합니다. (현재값: {value})",
    en: "Invalid Code format. CT codes must be 'C+digits', Custom codes must be '*'. (current value: {value}).",
  },
  MY_DICTIONARY_VALIDATION_CODELIST_CODE_FORMAT_RULE: {
    ko: "Codelist Code 형식이 잘못되었습니다. CT는 'C숫자' 형식, Custom은 '*' 형식이어야 합니다. (현재값: {value})",
    en: "Invalid Codelist Code format. CT codes must be 'C+digits', Custom codes must be '*'. (current value: {value}).",
  },
  MY_DICTIONARY_VALIDATION_CODELIST_EXTENSIBLE_VALUE_RULE: {
    ko: "Codelist Extensible은 'YES' 또는 'NO' 값만 허용됩니다. (현재값: {value})",
    en: "Codelist Extensible must be 'YES' or 'NO'. (current value: {value}).",
  },
  MY_DICTIONARY_VALIDATION_RANK_NUMERIC_FORMAT_RULE: {
    ko: "Rank는 숫자여야 합니다. (현재값: {value})",
    en: "Rank must be a number. (current value: {value}).",
  },
  MY_DICTIONARY_VALIDATION_TERM_CODE_INTEGRITY_RULE: {
    ko: "Codelist Code '{value}'이 Group Code로 존재하지 않습니다. 상위 그룹 코드를 먼저 등록해주세요.",
    en: "Codelist Code '{value}' does not exist as a Group Code. Please add the parent group code first.",
  },
  MY_DICTIONARY_VALIDATION_CUSTOM_CODE_RULE: {
    ko: "Custom 하위 코드는 Code와 Codelist Code 모두 '*'이어야 합니다.",
    en: "Custom sub codes must have '*' in both Code and Codelist Code.",
  },
  MY_DICTIONARY_VALIDATION_GROUP_CUSTOM_CODE_RULE: {
    ko: "Custom 그룹 코드는 Code만 '*'이고 Codelist Code는 비어있어야 합니다.",
    en: "Custom group codes must have '*' only in Code, with empty Codelist Code.",
  },
  MY_DICTIONARY_VALIDATION_NON_EXTENSIBLE_CODE_RULE: {
    ko: "Extensible='NO'인 Codelist '{value}'에 Custom Code('*')를 포함할 수 없습니다.",
    en: "Cannot include Custom Code('*') in non-extensible Codelist '{value}'.",
  },
  MY_DICTIONARY_VALIDATION_DUPLICATION_CODE_RULE: {
    ko: "중복된 코드입니다.",
    en: "Duplicate code.",
  },
  MY_DICTIONARY_VALIDATION_STANDARD_CODE_COMPLIANCE_RULE: {
    ko: "Code '{value}'이 SDTMIG CT에 존재하지 않습니다. SDTMIG에 등록된 CT Code인지 확인해주세요.",
    en: "Code '{value}' not found in SDTMIG CT. Please verify this is a valid SDTMIG CT Code.",
  },
  MY_DICTIONARY_VALIDATION_STANDARD_VALUE_COMPLIANCE_RULE: {
    ko: "SDTM CT 코드 정보와 일치하지 않습니다.",
    en: "SDTM CT code information does not match.",
  },
  MY_DICTIONARY_VALIDATION_CODELIST_NAME_MAX_LENGTH_RULE: {
    ko: "Codelist name 길이가 최대 허용 길이(200자)를 초과했습니다. (현재: {value}자)",
    en: "Codelist name length exceeds maximum allowed length(200). (current: {value})",
  },
  MY_DICTIONARY_VALIDATION_SUBMISSION_VALUE_MAX_LENGTH_RULE: {
    ko: "CDISC Submission Value 길이가 최대 허용 길이(100자)를 초과했습니다. (현재: {value}자)",
    en: "CDISC Submission Value length exceeds maximum allowed length(100). (current: {value})",
  },
  MY_DICTIONARY_VALIDATION_DECODED_VALUE_MAX_LENGTH_RULE: {
    ko: "Decoded value 길이가 최대 허용 길이(500자)를 초과했습니다. (현재: {value}자)",
    en: "Decoded value length exceeds maximum allowed length(500). (current: {value})",
  },
  MY_DICTIONARY_VALIDATION_SYSTEM_ID_MATCH_RULE: {
    ko: "존재하지 않는 SystemID입니다.",
    en: "System ID does not exist.",
  },
  MY_DICTIONARY_VALIDATION_LOADING: {
    ko: "파일을 검증하는 중입니다.\n잠시만 기다려 주세요.",
    en: "Verifying the file... Please wait a moment.",
  },
  MY_DICTIONARY_VALIDATION_PROCEED_LOADING: {
    ko: "데이터를 반영하는 중입니다.\n잠시만 기다려 주세요.",
    en: "Applying changes...",
  },
};
//
MvnCodeInitiate(CONVERTER_MY_DICTIONARY_LANG);
